import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
    stripeTest: 'pk_test_uZ7yB0AI3ug45p86lpdIyFKU',
    stripeLive: 'pk_live_yBsjI4318JrU4SseiNAZZxxb',
    orderId: '',
    customerId: '',
    eventId: '',
    event: {},
    items: {},
    screenType: 0,
    totalPrice: 0,
    loading: false,
    errorText: '',
    chargeId: '',
});

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {
        
        case types.CUSTOMER_ID_SET:
            return state.merge({
                customerId: action.value,
            });

        case types.ORDER_ID_SET:
            return state.merge({
                orderId: action.value,
            });

        case types.EVENT_ID_SET:
            return state.merge({
                eventId: action.value,
            });

        case types.EVENT_SET:
            return state.merge({
                event: action.value,
            });

        case types.ITEMS_SET:
            return state.merge({
                items: action.value,
            });

        case types.PHONE_SET:
            return state.merge({
                phone: action.value,
            });

        case types.SCREEN_SET:
            return state.merge({
                screenType: action.value,
            });

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            });

        case types.ERROR_SET:
            return state.merge({
                errorText: action.value,
            });

        case types.CHARGE_ID_SET:
            return state.merge({
                chargeId: action.value,
            });

        case types.TOTAL_PRICE_SET:
            return state.merge({
                totalPrice: action.value,
            });

        default:
            return state;
    }
}

export function getPhone(state) {
    return state.payCheck.phone
}

export function getScreenType(state) {
    return state.payCheck.screenType
}

export function getStripeLive(state) {
    return state.payCheck.stripeLive
}

export function getStripeTest(state) {
    return state.payCheck.stripeTest
}

export function getLoading(state) {
    return state.payCheck.loading
}

export function getError(state) {
    return state.payCheck.errorText
}

export function getModal(state) {
    return state.payCheck.modal
}

export function getCustomerId(state) {
    return state.payCheck.customerId
}

export function getOrderId(state) {
    return state.payCheck.orderId
}

export function getEventId(state) {
    return state.payCheck.eventId
}

export function getEvent(state) {
    return state.payCheck.event
}

export function getItems(state) {
    return state.payCheck.items
}

export function getChargeId(state) {
    return state.payCheck.chargeId
}

export function getTotalPrice(state) {
    return state.payCheck.totalPrice
}

export function getFee(state) {
    return state.payCheck.event ? state.payCheck.event.fee : 0
}
